(function (angular, app) {
    'use strict';

    app
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('app.categoryProducts', {
                url: '/categories/:cid/products?{filters:json}&{sort:json}&{events:json}&page',
                data: {
                    name: 'category-products'
                },
                reloadOnSearch: false,
                resolve: {
                    categories: ['$rootScope','$state', '$stateParams', 'Util', function ($rootScope,$state, $stateParams, util) {
                        return util.getCategory($stateParams.cid).then(function(categories) {
                            if (categories) {
                                $rootScope.$emit('categoryPage',categories);
                            }
                            return categories || [];
                        });
                    }]
                },
                metaTags: {
                    title: ['$filter', 'categories', function($filter, categories) {
                        if (categories && categories.length) {
                            return $filter('name')(categories[0].names);
                        }
                    }],
                    description: ['$filter', 'categories', function ($filter, categories) {
                        if (!categories || !categories.length) {
                            return;
                        }

                        for (var i = 0; i < categories.length; i++) {
                            if (categories[i].description) {
                                return categories[i].description;
                            }
                        }

                        return $filter('name')(categories[0].names);
                    }],
                    keywords: ['$filter', 'categories', function ($filter, categories) {
                        if (!categories || !categories.length) {
                            return;
                        }

                        for (var i = 0; i < categories.length; i++) {
                            if (categories[i].keywords) {
                                return categories[i].keywords;
                            }
                        }

                        return $filter('name')(categories[0].names);
                    }]
                },
                views: {
                    '@': {
                        templateUrl: 'template/views/category-products/index.html',
                        controller: 'CategoryProductsCtrl as categoryCtrl'
                    }
                }
            });
        }])
        .controller('CategoryProductsCtrl', [
            '$scope', '$rootScope', '$filter', '$q', '$state', '$stateParams', '$location', '$timeout', 'Api', 'Util', 'Items',
            'Cart', 'FilterManager', 'User', 'categories', 'CATEGORIES_TYPES', 'ADVERTISEMENT_CONVERSION_TYPE', 'Config', 'DataLayer',
            function ($scope, $rootScope, $filter, $q, $state, $stateParams, $location, $timeout, api, util, Items,
                      cart, FilterManager, User, categories, CATEGORIES_TYPES, ADVERTISEMENT_CONVERSION_TYPE, Config, DataLayer) {
                var categoryCtrl = this;

                var roboticBranchOrderSettings = Config.getCurrentBranchRoboticOrderHandlingSettings();

                $rootScope.roboticBranchOrderSettings = roboticBranchOrderSettings;

                var _isRetailerPremiumReplacementsEnabled = Config.retailer.settings.enablePersonalReplacement;
                var _currentPage = parseInt($stateParams.page, 10) || 1;
                var _deeplinkPage = parseInt($stateParams.page, 10) || 1;
                var _catalogOffsetBase = null;
                var _shouldScrollToPage = _currentPage > 1;
                var _prependInFlight = false;
                var _paginationChunkSize = null;
                var _urlPageSyncTimeout = null;
                var _TOP_SCROLL_LOAD_THRESHOLD = 500;
                $rootScope.spMixPanel.trackProperties({
                    source: $rootScope.SP_SERVICES.SOURCES.CATEGORY_PAGE
                });
                angular.extend(categoryCtrl, {
                    products: [],
                    total: 0,
                    openProduct: openProduct,
                    category: (categories && categories.length) ? categories : {},

                    roboticBranchOrderSettings: roboticBranchOrderSettings,

                    productTagsFilter: FilterManager.getProductTagsFilter(_onChangeFilters, $scope, false),
                    brandFilter: FilterManager.getBrandsFilter(_onChangeFilters),
                    familiesFilter: FilterManager.getFamiliesFilter(_onChangeFilters),
                    supervisionsFilter: FilterManager.getSupervisionFilter(_onChangeFilters),
                    orderSorter: {
                        namesNgFilter: $filter('translate'),
                        title: 'Order items by',
                        defaultText: 'Select',
                        options: {
                            items: [
                                {
                                    name: 'Price high-low',
                                    field: 'branch.regularPrice',
                                    desc: true
                                },
                                {
                                    name: 'Price low-high',
                                    field: 'branch.regularPrice',
                                    desc: false
                                }
                            ]
                        },
                        onChange: _onChangeFilters
                    },
                    groupBy: {
                        titleStyleClass: 'family-group-title',
                        by: 'family.id',
                        value: 'family',
                        isOneColumn: '(names | name).long.length > 50',
                        templateUrl: 'template/views/category-products/partials/menu-family-group-title/index.html',
                        itemHeightRatio: '(names | name).short != (names | name).long ? 1.5 : 1'
                    }
                });

                categoryCtrl.events = $stateParams.events;
                $location.search('events', null);

                _initCategory();
                _initFilters();

                /**
                 * Initializes the filters and sort values and options
                 * @private
                 */
                function _initFilters() {
                    if (categoryCtrl.category._actualType == CATEGORIES_TYPES.MENU) {
                        _initMenuFilters()
                        return;
                    }

                    categoryCtrl.sorters = [categoryCtrl.orderSorter];
                    categoryCtrl.filters = [categoryCtrl.productTagsFilter, categoryCtrl.familiesFilter, categoryCtrl.brandFilter];
                    $rootScope.config.retailer.allowSupervisionFilter && (categoryCtrl.filters.push(categoryCtrl.supervisionsFilter));

                    FilterManager.setFiltersFromUrl({
                        productTag: categoryCtrl.productTagsFilter,
                        family: categoryCtrl.familiesFilter,
                        brand: categoryCtrl.brandFilter,
                        supervision: categoryCtrl.supervisionsFilter
                    }, $stateParams.filters, categoryCtrl.orderSorter, $stateParams.sort);

                    if (categoryCtrl.category && categoryCtrl.category.id) {
                        api.request({
                            url: '/v2/retailers/:rid/branches/:bid/categories/' + categoryCtrl.category.id + '/products/filters'
                        }, {
                            fireAndForgot: true
                        }).then(function (results) {
                            FilterManager.addProductTagsFilterOptions(categoryCtrl.productTagsFilter, results.productTags, true);
                            FilterManager.addBrandsFilterOptions(categoryCtrl.brandFilter, results.brands);
                            FilterManager.addFamiliesFilterOptions(categoryCtrl.familiesFilter, results.families);
                            FilterManager.addSupervisionsFilterOptions(categoryCtrl.supervisionsFilter, results.supervisions);
                        }).finally(function () {
                            FilterManager.markFiltersAsFinished([categoryCtrl.productTagsFilter, categoryCtrl.brandFilter, categoryCtrl.familiesFilter, categoryCtrl.supervisionsFilter]);
                        });
                    } else {
                        FilterManager.markFiltersAsFinished([categoryCtrl.productTagsFilter, categoryCtrl.brandFilter, categoryCtrl.familiesFilter, categoryCtrl.supervisionsFilter]);
                    }
                }

                function _initMenuFilters(){
                    categoryCtrl.sorters = null
                    categoryCtrl.filters = [categoryCtrl.productTagsFilter];
                    FilterManager.setFiltersFromUrl({
                        productTag: categoryCtrl.productTagsFilter,
                    }, $stateParams.filters, null, null);

                    if (categoryCtrl.category && categoryCtrl.category.id) {
                        api.request({
                            url: '/v2/retailers/:rid/branches/:bid/categories/' + categoryCtrl.category.id + '/products/filters'
                        }, {
                            fireAndForgot: true
                        }).then(function (results) {
                            FilterManager.addProductTagsFilterOptions(categoryCtrl.productTagsFilter, results.productTags, true);
                        }).finally(function () {
                            FilterManager.markFiltersAsFinished([categoryCtrl.productTagsFilter]);
                        });
                    } else {
                        FilterManager.markFiltersAsFinished([categoryCtrl.productTagsFilter]);
                    }

                }
                function openProduct(product, index) {
                    if (product.isBumper) {
                        return;
                    }

                    util.openProduct(product, {
                        next: _nextProduct,
                        previous: _previousProduct,
                        siblings: [Items.items[index - 1], Items.items[index - 2], Items.items[index + 1], Items.items[index + 2]],
                        total: categoryCtrl.total,
                        index: index,
                        source: $rootScope.SP_SERVICES.SOURCES.CATEGORY_PAGE
                    });
                }

                function _onChangeFilters() {
                    FilterManager.setFiltersToUrl({
                        productTag: categoryCtrl.productTagsFilter,
                        family: categoryCtrl.familiesFilter,
                        brand: categoryCtrl.brandFilter,
                        supervisions: categoryCtrl.supervisionsFilter
                    }, categoryCtrl.orderSorter);

                    _currentPage = 1;
                    _deeplinkPage = 1;
                    _catalogOffsetBase = null;
                    _paginationChunkSize = null;
                    $location.search('page', null);
                    Items.resetItems();
                    categoryCtrl.products.splice(0, categoryCtrl.products.length);
                    return _addChunkToProducts(true);
                }

                /**
                 * Shared ES query for category product chunks (append or prepend).
                 */
                function _buildCategoryProductsParams(from, requestedSize) {
                    var params = {
                        from: from,
                        size: requestedSize,
                        languageId: $rootScope.config.language.id,
                        minScore: 0
                    };

                    params.names = [];

                    angular.forEach(categories, function (category) {
                        angular.forEach(category.names, function (value) {
                            params.names.push(value);
                        });
                    });

                    FilterManager.parseFilters(params, [categoryCtrl.productTagsFilter, categoryCtrl.brandFilter, categoryCtrl.familiesFilter, categoryCtrl.supervisionsFilter]);

                    var sort = [],
                        categorySort = _getCategorySort();
                    if (categoryCtrl.category._actualType == CATEGORIES_TYPES.MENU) {
                        sort.push({'family.id': 'asc'});
                        if (!categorySort) {
                            sort.push({'localBarcode.raw': 'asc'});
                        } else {
                            params.categorySort = categorySort;
                        }
                    } else if (categoryCtrl.orderSorter.value) {
                        var paramsSort = {};
                        paramsSort[categoryCtrl.orderSorter.value.field] = categoryCtrl.orderSorter.value.desc ? 'desc' : 'asc';
                        sort = [paramsSort];
                    } else {
                        params.categorySort = categorySort;
                    }

                    if (sort.length) {
                        params.sort = sort;
                    }

                    if (Config.retailer.settings.showUnavailableProducts !== 'true') {
                        var filterJsonShowUnavailableProducts = {
                            "mustNot": {
                                "term": {
                                    "branch.isOutOfStock": true
                                }
                            }
                        };
                        if (params.filters) {
                            Object.assign(params.filters, filterJsonShowUnavailableProducts);
                        } else {
                            params.filters = filterJsonShowUnavailableProducts;
                        }

                    }
                    else {
                        var filterJson = {
                            "should": [
                                {
                                    "bool": {
                                        "must_not": {
                                            "exists": {
                                                "field": "branch.outOfStockShowUntilDate"
                                            }
                                        }
                                    }
                                },
                                {
                                    "bool": {
                                        "must": [
                                            {
                                                "range": {
                                                    "branch.outOfStockShowUntilDate": {
                                                        "gt": "now"
                                                    }
                                                }
                                            },
                                            {
                                                "term": {
                                                    "branch.isOutOfStock": true
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "bool": {
                                        "must": [
                                            {
                                                "term": {
                                                    "branch.isOutOfStock": false
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        };
                        if (Config.retailer.settings.isOutOfStockDuration === 'true') {
                            if (params.filters) {
                                params.filters.bool = filterJson;
                            } else {
                                params.filters = {"bool": filterJson};
                            }
                        }
                    }

                    return params;
                }

                function _addChunkToProducts(isInit) {
                    if ($rootScope.suggestionsDialogOpened) {
                        return;
                    }

                    var totalItems = Items.getItemsLength();
                    if (!isInit && (totalItems == categoryCtrl.total || categoryCtrl.total == categoryCtrl.products.length)) {
                        return;
                    }

                    if (!categoryCtrl.category || !categoryCtrl.category.id) {
                        categoryCtrl.total = 0;
                        return $q.resolve({products: [], total: 0});
                    }

                    return Items.getChunkAmount().then(function(size) {
                        if (_catalogOffsetBase === null) {
                            _catalogOffsetBase = (_deeplinkPage - 1) * size;
                        }
                        _paginationChunkSize = size;

                        var params = _buildCategoryProductsParams(_catalogOffsetBase + totalItems, size);

                        return Items.getItems({
                            url: '/v2/retailers/:rid/branches/:bid/categories/' + categoryCtrl.category.id + '/products',
                            params: params
                        });
                    }).then(function (resp) {
                        var currentProductsCount = categoryCtrl.products.length;
                        var chunks = Items.insertBumpersToChunk(cart.getProducts(resp.products))
                        if (_isRetailerPremiumReplacementsEnabled) {
                            var linesForSuggestions = [];
                            
                            angular.forEach(chunks, function (chunk) {

                                if (chunk && chunk.branch && chunk.branch.isOutOfStock) {
                                    linesForSuggestions.push(chunk);
                                }
                            });

                            if (linesForSuggestions.length) {
                                util.setReplacements(linesForSuggestions);
                            }

                        }
                        util.pushAll(categoryCtrl.products, chunks);
                        categoryCtrl.total = resp.total === 0 || resp.total ? resp.total : categoryCtrl.total;
                        util.setProductIndexPosition(resp.products);
                        DataLayer.push(DataLayer.EVENTS.VIEW_ITEM_LIST, {products: resp.products, data: {productsStartingPosition: currentProductsCount}});
                        
                        if (!isInit && resp.products.length > 0) {
                            _currentPage++;
                            $location.search('page', _currentPage > 1 ? _currentPage : null).replace();
                        } else if (isInit && _currentPage > 1 && resp.products.length > 0) {
                            $location.search('page', _currentPage).replace();
                            
                            if (_shouldScrollToPage) {
                                var pageForScroll = _currentPage;
                                _shouldScrollToPage = false;
                                $timeout(function() {
                                    _scrollToPage(pageForScroll, true);
                                }, 1000);
                            }
                        }

                        if (!isInit && resp.products.length > 0) {
                            $timeout(function() {
                                _scheduleSyncVisiblePageToUrl(null, 250);
                            }, 0);
                        } else {
                            $timeout(function() {
                                _scheduleSyncVisiblePageToUrl();
                            }, 0);
                        }
                        
                        return resp;
                    });
                }

                function _prependChunkToProducts(domEvent) {
                    if ($rootScope.suggestionsDialogOpened || _prependInFlight) {
                        return;
                    }
                    if (!categoryCtrl.category || !categoryCtrl.category.id) {
                        return;
                    }
                    if (_catalogOffsetBase <= 0) {
                        return;
                    }
                    if (Items.isChunkInProcess()) {
                        return;
                    }
                    if ($rootScope.endlessScrollCounter) {
                        return;
                    }

                    _prependInFlight = true;
                    var scrollEl = domEvent ? util.getDocumentScrolledElement(domEvent) : (document.scrollingElement || document.documentElement || document.body);
                    var oldScrollTop = scrollEl.scrollTop;
                    var oldScrollHeight = scrollEl.scrollHeight;

                    return Items.getChunkAmount().then(function(size) {
                        _paginationChunkSize = size;
                        var prevFrom = Math.max(0, _catalogOffsetBase - size);
                        var prevSize = _catalogOffsetBase - prevFrom;
                        if (prevSize <= 0) {
                            _prependInFlight = false;
                            return $q.resolve(null);
                        }
                        var params = _buildCategoryProductsParams(prevFrom, prevSize);
                        return Items.getItems({
                            url: '/v2/retailers/:rid/branches/:bid/categories/' + categoryCtrl.category.id + '/products',
                            params: params
                        }).then(function(resp) {
                            if (!resp || !resp.products.length) {
                                _prependInFlight = false;
                                return resp;
                            }

                            _catalogOffsetBase = prevFrom;

                            var chunks = Items.insertBumpersToChunk(cart.getProducts(resp.products));
                            if (_isRetailerPremiumReplacementsEnabled) {
                                var linesForSuggestions = [];
                                angular.forEach(chunks, function (chunk) {
                                    if (chunk && chunk.branch && chunk.branch.isOutOfStock) {
                                        linesForSuggestions.push(chunk);
                                    }
                                });
                                if (linesForSuggestions.length) {
                                    util.setReplacements(linesForSuggestions);
                                }
                            }

                            Array.prototype.unshift.apply(categoryCtrl.products, chunks);
                            categoryCtrl.total = resp.total === 0 || resp.total ? resp.total : categoryCtrl.total;
                            util.setProductIndexPosition(resp.products);
                            DataLayer.push(DataLayer.EVENTS.VIEW_ITEM_LIST, {products: resp.products, data: {productsStartingPosition: 0}});

                            $timeout(function() {
                                scrollEl.scrollTop = oldScrollTop + (scrollEl.scrollHeight - oldScrollHeight);
                                _prependInFlight = false;
                                _scheduleSyncVisiblePageToUrl(scrollEl);
                            }, 0);

                            return resp;
                        });
                    }).catch(function() {
                        _prependInFlight = false;
                    });
                }

                /**
                 * Index of the product tile best representing "current scroll page": closest vertical mid to viewport center.
                 * Avoids treating only upper-viewport cells as visible (which broke page when scrolled near the list bottom).
                 */
                function _getViewportAnchorProductIndex(productElements) {
                    var vh = window.innerHeight;
                    var centerY = vh * 0.5;
                    var bestIdx = -1;
                    var bestDist = Infinity;
                    var i;
                    var r;
                    for (i = 0; i < productElements.length; i++) {
                        r = productElements[i].getBoundingClientRect();
                        if (r.bottom <= 0 || r.top >= vh) {
                            continue;
                        }
                        var midY = (r.top + r.bottom) * 0.5;
                        var dist = Math.abs(midY - centerY);
                        if (dist < bestDist) {
                            bestDist = dist;
                            bestIdx = i;
                        }
                    }
                    if (bestIdx >= 0) {
                        return bestIdx;
                    }
                    for (i = 0; i < productElements.length; i++) {
                        r = productElements[i].getBoundingClientRect();
                        if (r.bottom > 0 && r.top < vh) {
                            return i;
                        }
                    }
                    return -1;
                }

                function _syncVisiblePageToUrl(scrollEl) {
                    if (!$state.includes('app.categoryProducts')) {
                        return;
                    }
                    var chunkSize = _paginationChunkSize;
                    if (!chunkSize) {
                        Items.getChunkAmount().then(function(cs) {
                            _paginationChunkSize = cs;
                            _syncVisiblePageToUrl(scrollEl);
                        });
                        return;
                    }
                    if (!categoryCtrl.total) {
                        return;
                    }

                    var productElements = document.querySelectorAll('sp-items .item.product');
                    if (!productElements.length) {
                        return;
                    }

                    var visibleIdx = _getViewportAnchorProductIndex(productElements);
                    if (visibleIdx < 0) {
                        return;
                    }

                    var catalogIndex = _catalogOffsetBase + visibleIdx;
                    var page = Math.floor(catalogIndex / chunkSize) + 1;
                    var totalPages = Math.max(1, Math.ceil(categoryCtrl.total / chunkSize));
                    if (page > totalPages) {
                        page = totalPages;
                    }
                    if (page < 1) {
                        page = 1;
                    }

                    var urlPage = parseInt($location.search().page, 10) || 1;
                    if (page === urlPage) {
                        _currentPage = page;
                        return;
                    }

                    _currentPage = page;
                    $location.search('page', page > 1 ? page : null).replace();
                }

                function _scheduleSyncVisiblePageToUrl(scrollEl, delayMs) {
                    if (_urlPageSyncTimeout) {
                        $timeout.cancel(_urlPageSyncTimeout);
                    }
                    var wait = angular.isDefined(delayMs) ? delayMs : 100;
                    _urlPageSyncTimeout = $timeout(function() {
                        _urlPageSyncTimeout = null;
                        var el = scrollEl || (document.scrollingElement || document.documentElement || document.body);
                        _syncVisiblePageToUrl(el);
                    }, wait);
                }

                function _scrollToPage(pageNumber, deepLinkedSinglePage) {
                    return Items.getChunkAmount().then(function(chunkSize) {
                        var targetPageStartIndex = deepLinkedSinglePage ? 0 : chunkSize * (pageNumber - 1);
                        var productElements = document.querySelectorAll('sp-items .item.product');
                        
                        if (productElements && productElements.length > targetPageStartIndex) {
                            var targetElement = productElements[targetPageStartIndex];
                            if (targetElement) {
                                targetElement.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                        } 
                    });
                }

                function _getCategorySort() {
                    var categorySorts = [];

                    var categoryWithSort = categories.find(function(node) {
                        return !!node.categorySort;
                    });
                    if (categoryWithSort && categoryWithSort.categorySort) {
                        angular.forEach(categoryWithSort.categorySort, function(categorySortItem) {
                            categorySorts.push({
                                sortType: categorySortItem.sortType,
								topPriority: categorySortItem.topPriority && (angular.toJson(JSON.parse(categorySortItem.topPriority).map(function(x) {
									return {id: x.id};
								})))
                            });
                        });
                    }

                    var userPurchasesSortBoost = User.getPurchasesSortBoost();
                    if (userPurchasesSortBoost) {
                        categorySorts.push(userPurchasesSortBoost);
                    }

                    var productTagsSortBoost = FilterManager.getProductTagsSortBoost(categoryCtrl.productTagsFilter);
                    if (productTagsSortBoost) {
                        categorySorts.push(productTagsSortBoost);
                    }

                    if (categorySorts.length) {
                        return categorySorts;
                    }
                }

                function _nextProduct(index) {
                    var totalItemsWithoutBumpers = Items.getItemsLength(),
                        nextProductData = Items.getNextProductData(index, 1);
                    if (categoryCtrl.total != totalItemsWithoutBumpers && !nextProductData.product) {
                        return _addChunkToProducts().then(function () {
                            return _nextProduct(index);
                        });
                    }

                    nextProductData.total = Items.items.length + categoryCtrl.total - totalItemsWithoutBumpers;
                    return $q.resolve(nextProductData);
                }

                function _previousProduct(index) {
                    var nextProductData = Items.getNextProductData(index, -1);
                    nextProductData.total = Items.items.length + categoryCtrl.total - Items.getItemsLength();
                    return $q.resolve(nextProductData);
                }

                function _initCategory() {
                    var actualType;
                    if (categories && angular.isArray(categories) && categories.length) {
                        categoryCtrl.category = categories[0];

                        DataLayer.push(DataLayer.EVENTS.SELECT_CONTENT, {data: {category: 'Menu', action: 'Click', label: categoryCtrl.category.names}});

                        //for tests
                        //categoryCtrl.category.type = categoryCtrl.category.id == 78067 ? CATEGORIES_TYPES.MENU : categoryCtrl.category.type;
                        var imageUrl;
                        for (var i = 0; i < categories.length; i++) {
                            if (!imageUrl && !!categories[i].siteImage) {
                                imageUrl = categories[i].siteImage;
                            }
                            if (!actualType && !!categories[i].type && categories[i].type != CATEGORIES_TYPES.INHERIT) {
                                actualType = categories[i].type;
                            }

                            if (imageUrl && actualType) break;
                        }
                        categoryCtrl.category._siteImage = imageUrl || (categories[categories.length - 1].imageUrl || '').replace('normal', 'big');

                        util.setCurrentCategory(categories, $scope);
                    } else {
                        if (!categoryCtrl.category || angular.equals(categoryCtrl.category, {})) {
                            categoryCtrl.category = {
                                id: $stateParams.cid,
                                names: {},
                                _siteImage: ''
                            };
                        }
                        actualType = categoryCtrl.category.type;
                        util.setCurrentCategory(categoryCtrl.category, $scope);
                    }
                    categoryCtrl.category._actualType = actualType || CATEGORIES_TYPES.REGULAR;

                    if (categoryCtrl.category && !angular.equals(categoryCtrl.category, {})) {
                        _checkSubCategoriesType(categoryCtrl.category);
                    }
                }

                function _checkSubCategoriesType(category) {
                    if (categoryCtrl.category._actualType != CATEGORIES_TYPES.MENU) return;

                    if (category.type == CATEGORIES_TYPES.REGULAR) {
                        return categoryCtrl.category._actualType = CATEGORIES_TYPES.REGULAR;
                    }

                    angular.forEach(category.subCategories || [], _checkSubCategoriesType);
                }

                /**Listeners*/
                util.currentScopeListener($scope, $rootScope.$on('document.scroll', function(angularEvent, domEvent) {
                    if (!$state.includes('app.categoryProducts')) {
                        return;
                    }
                    var scrollEl = domEvent ? util.getDocumentScrolledElement(domEvent) : (document.scrollingElement || document.documentElement || document.body);
                    if (scrollEl.scrollTop < _TOP_SCROLL_LOAD_THRESHOLD && _catalogOffsetBase > 0 && !_prependInFlight &&
                        !$rootScope.endlessScrollCounter && !$rootScope.suggestionsDialogOpened) {
                        _prependChunkToProducts(domEvent);
                    }
                    _scheduleSyncVisiblePageToUrl(scrollEl);
                }));

                util.currentScopeListener($scope, $rootScope.$on('items.initiated', function () {
                    _addChunkToProducts(true);
                }));

                util.currentScopeListener($scope, $rootScope.$on('cart.lines.add', function (event, data) {
                    if (categoryCtrl.products.length && categoryCtrl.events) {
                        util.firePromotionEvent(categoryCtrl.events[ADVERTISEMENT_CONVERSION_TYPE.ADD_TO_CART]);
                        if (data.lines && data.lines.length) {
                            data.lines[0].adConversionUrl = categoryCtrl.events[ADVERTISEMENT_CONVERSION_TYPE.CHARGE];
                        }
                    }
                    angular.forEach(categoryCtrl.products, function (product, index) {
                        if (product.isBumper) return;
                        categoryCtrl.products[index] = cart.getProduct(product);
                    });
                }));

                util.currentScopeListener($scope, $rootScope.$on('document.scroll.end', function (data, event) {
                    event.start();
                    var promise = _addChunkToProducts();
                    if (promise) {
                        promise.finally(function () {
                            event.done();
                        });
                    } else {
                        event.done();
                    }
                }));
                util.currentScopeListener($scope, $rootScope.$on('items.add', function () {
                    _addChunkToProducts();
                }));

                util.currentScopeListener($scope, $scope.$on('$destroy', function () {
                    if (_urlPageSyncTimeout) {
                        $timeout.cancel(_urlPageSyncTimeout);
                    }
                }));
            }])

        //those controllers should move to their template
        .controller('PrutahTemplateCategoryProductsCtrl', ['$scope', 'Items', 'CATEGORIES_TYPES', 'SP_ITEMS_DESIGNS', function($scope, Items, CATEGORIES_TYPES, SP_ITEMS_DESIGNS) {
            var categoryCtrl = $scope.categoryCtrl;

            Items.initPage({
                defaultWidth: categoryCtrl.category._actualType === CATEGORIES_TYPES.LARGE_ITEMS ? 370 : 210,
                design: categoryCtrl.category._actualType === CATEGORIES_TYPES.MENU && SP_ITEMS_DESIGNS.MENU,
                isSingleBumper: categoryCtrl.category._actualType === CATEGORIES_TYPES.LARGE_ITEMS
            });
        }])
        .controller('KikarTemplateCategoryProductsCtrl', ['$scope', 'Items', 'CATEGORIES_TYPES', 'SP_ITEMS_DESIGNS', function($scope, Items, CATEGORIES_TYPES, SP_ITEMS_DESIGNS) {
            var categoryCtrl = $scope.categoryCtrl;
            Items.initPage({
                defaultWidth: categoryCtrl.category._actualType === CATEGORIES_TYPES.LARGE_ITEMS ? 350 : 235,
                design: categoryCtrl.category._actualType === CATEGORIES_TYPES.MENU && SP_ITEMS_DESIGNS.MENU,
                isSingleBumper: categoryCtrl.category._actualType === CATEGORIES_TYPES.LARGE_ITEMS
            });
        }]);
})(angular, app);
